import React from 'react'
import JiaMengHeader from '@components/JiaMeng/Header/Schedule'
import { asyncLoad } from '@util'

const AsyncSchedule = asyncLoad(() => import('@components/JiaMeng/Schedule'))

export default {
  path: 'schedule',
  component: props => <JiaMengHeader key="schedule" {...props} />,
  indexRoute: {
    component: AsyncSchedule
  },
  stat: '加盟店日程管理/首页'
}
